import { Add, Remove } from "@mui/icons-material";
import { Box, InputAdornment, TextField } from "@mui/material";
import { GetData } from "contexts/DataContext";
import React from "react";

export function ZoomField(props) {
  const { dataObj, forceSetDataObj } = GetData();
  const [zoom, setZoom] = React.useState(Number(dataObj?.zoom || "100"));

  React.useEffect(() => {
    setZoom(Number(dataObj?.zoom || "100"));
  }, [dataObj?.zoom]);

  React.useEffect(() => {
    forceSetDataObj(zoom, "zoom");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoom]);

  function changeZoom(add) {
    let current = zoom;
    let newZoom = 0;
    if (add) {
      if (current >= 120) newZoom = current;
      else newZoom = current + 10;
    } else if (current >= 50) {
      newZoom = current - 10;
    } else {
      newZoom = current;
    }
    setZoom(newZoom);
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <TextField
        InputProps={{
          disabled: true,
          endAdornment: (
            <InputAdornment
              onClick={(e) => {
                changeZoom(true);
              }}
              position="end"
            >
              <Add />
            </InputAdornment>
          ),
          startAdornment: (
            <InputAdornment
              onClick={(e) => {
                changeZoom(false);
              }}
              position="start"
            >
              <Remove />
            </InputAdornment>
          ),
          style: {
            // fontSize: dataObj?.deviceWidth?.isMobile
            //   ? "0.875rem"
            //   : "1rem",
          },
        }}
        // fullWidth
        inputProps={{
          maxLength: 3,
          style: { textAlign: "center" },
        }}
        label="Масштаб"
        mb={2}
        mt={2}
        name="zoom"
        sx={{
          margin: "0.875rem 0",
          // width: "180px",
          textAlign: "center !important",
        }}
        type="text"
        value={zoom + "%" || "100%"}
        variant="standard"
      />
    </Box>
  );
}
